import $ from "jquery";

function scrollCarousel(carouselInner: JQuery<HTMLElement>, offset: number) {
    const slides = carouselInner.children();
    const slideWidth = 96;
    const currentScroll = carouselInner.scrollLeft() ?? 0;
    const newScroll = currentScroll + offset;

    if (newScroll >= slides.length * slideWidth) {
        carouselInner.scrollLeft(0);
    } else if (newScroll < 0) {
        carouselInner.scrollLeft((slides.length - 1) * slideWidth);
    } else {
        carouselInner.scrollLeft(newScroll);
    }
}

export function nextEvaluationKitCarouselSlide(element: JQuery<HTMLElement>) {
    const carouselInner = element.closest(".evaluation-carousel").find(".evaluation-carousel-images");
    scrollCarousel(carouselInner, 96);
}

export function prevEvaluationKitCarouselSlide(element: JQuery<HTMLElement>) {
    const carouselInner = element.closest(".evaluation-carousel").find(".evaluation-carousel-images");
    scrollCarousel(carouselInner, -96);
}

$(function () {
    $(".evaluation-carousel").on("click", ".next-kit", function () {
        nextEvaluationKitCarouselSlide($(this) as JQuery<HTMLElement>);
    });
    $(".evaluation-carousel").on("click", ".prev-kit", function () {
        prevEvaluationKitCarouselSlide($(this) as JQuery<HTMLElement>);
    });
});
